import { useLocation } from 'react-router';

const useSearchParams = () => {
  const { search } = useLocation();
  return new URLSearchParams(search);
};

export default useSearchParams;
